import {ICollectionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'
import {CollectionItemType} from '@toolify/server/src/models/mongoose/CollectionItemModel/enum/CollectionItemType'
import {
  IFolderCollectionItemPayload,
} from '@toolify/server/src/services/CollectionService/strategies/FolderCollectionItemTypeStrategy/types/IFolderCollectionItemTypeStrategyInterfaces'

export function getCollectionFolderPayload(item: ICollectionItemResponseInstance): IFolderCollectionItemPayload | null {
  if(item.collectionItemType !== CollectionItemType.Folder) {
    return null
  }
  return item.collectionItemTypePayload as IFolderCollectionItemPayload
}
